import moment from 'moment'

const backorder = {
  loading: false,
  list: {},
  remindProductValue: !!window?.remindMeCheckBox,
}

function removeItem(list, id) {
  const { [id]: removedItem, ...rest } = list
  // console.log('Removed item', id, removedItem);
  return rest
}

const BackOrderReducer = function (state = backorder, action) {
  switch (action.type) {
    case 'TOGGLE_BACKORDER_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'SET_BACKORDER_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'REMOVE_BACKORDER_ITEM': {
      const newList = removeItem(state.list, action.product.id)
      return {
        ...state,
        list: newList,
      }
    }
    case 'REMOVE_BACKORDER_ITEMS': {
      return {
        ...state,
        list: action.products,
      }
    }
    case 'SET_REMIND_PRODUCT_VALUE': {
      return {
        ...state,
        remindProductValue: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default BackOrderReducer
